/**
 * Remote control settings plugin.
 */

'use strict';

var Emitter = require('cjs-emitter'),
    gettextWrapper = require('mag-gettext'),
    provider = new Emitter(),

    enabledList = [],
    langs = core.environment.availableLanguages,
    api, storage, layouts, gettext;

provider.get = function () {
    return enabledList;
};

function buildList () {
    var data = {
            id: 'keyboardLayouts',
            name: gettext('Keyboard layouts'),
            description: gettext('Set the default keyboard layout language.'),
            icon: 'theme-icon-rc-vk',
            sections: [
                {
                    id: 'keyboardLayouts',
                    name: gettext('Keyboard layouts'),
                    description: gettext('Set the default keyboard layout language.'),
                    icon: 'theme-icon-rc-vk',
                    parent: 'system'
                }
            ],
            options: [],
            content: []
        },
        index;

    /**
     *
     * @param {Object} values - data to prepare
     * @param {Function} callback - result handler
     *
     * @this option
     */
    function prepareForRender ( values, callback ) {
        callback(layouts[this.index].enable);
    }

    /**
     *
     * @param {boolean} value - new state
     * @param {Function} callback - result handler
     *
     * @this option
     */
    function prepareForSave ( value, callback ) {
        var selectIndex = enabledList.indexOf(layouts[this.index].code);

        if ( value ) {
            layouts[this.index].enable = value;
            if ( selectIndex === -1 ) {
                enabledList.push(layouts[this.index].code);
            }
        } else if ( selectIndex !== -1 ) {
            if ( enabledList.length === 1 ) {
                // try to disable last
                core.notify({
                    title: gettext('None of the proposed layouts has been selected. Action has been canceled.'),
                    icon: 'alert',
                    type: 'warning',
                    timeout: 10000
                });

                // pass error: true
                callback(true);

                return;
            }
            layouts[this.index].enable = value;
            enabledList.splice(selectIndex, 1);

        }

        storage.setItem('layouts', layouts);
        provider.emit('update', enabledList);

        callback();
    }

    for ( index = 0; index < layouts.length; index++ ) {
        data.options.push({
            id: 'layout' + layouts[index].code,
            name: layouts[index].name,
            description: '',
            icon: 'theme-icon-rc-vk',
            render: api.renders.toggle,
            saveImmediate: true,
            data: {},
            index: index,
            prepareForRender: prepareForRender,
            prepareForSave: prepareForSave,
            parent: 'keyboardLayouts'
        });
    }

    return data;
}

function loadList () {
    var needAdd = true,
        index, selectIndex, mapLangs, mapLayouts;

    layouts = storage.getItem('layouts') || [];
    mapLangs = langs.map(function ( item ) {
        return item.code;
    });

    mapLayouts = layouts.map(function ( item ) {
        return item.code;
    });

    for ( index = 0; index < langs.length; index++ ) {
        selectIndex = mapLayouts.indexOf(langs[index].code);

        if ( selectIndex === -1 ) {
            layouts.push({
                code: langs[index].code,
                name: langs[index].name,
                enable: false
            });

            /* eslint-disable-next-line */
            continue;
        }
        if ( layouts[index].enable ) {
            needAdd = false;
            enabledList.push(layouts[index].code);
        }
    }

    if ( needAdd ) {
        if ( core.environment.language !== 'en' ) {
            enabledList.push(core.environment.language);
        }
        enabledList.push('en');
    }

    //delete unsupported languages
    for ( index = 0; index < layouts.length; index++ ) {
        selectIndex = mapLangs.indexOf(layouts[index].code);

        if ( selectIndex === -1 ) {
            layouts.splice(index, 1);
            index--;

            /* eslint-disable-next-line */
            continue;
        }

        if ( needAdd ) {
            if ( enabledList.indexOf(layouts[index].code) !== -1 ) {
                layouts[index].enable = true;
            }
        }
    }
}

module.exports = {
    onInit: function ( config, callback ) {
        storage = config.storage;
        loadList();
        if ( callback ) {
            callback();
        }
    },
    onSettingsInit: function ( config, callback ) {
        api = config.api;
        storage = config.storage;
        if ( !layouts ) {
            loadList();
        }

        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var data;

            gettext = gettextWrapper.gettext;
            data = buildList();

            callback(null, data);
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, provider);
    }
};
